var _style, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientBd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 960,
    y1: 9.094947e-13,
    x2: 960,
    y2: 1080,
    gradientTransform: "matrix(-1 0 0 -1 1920 1080)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1B2C58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1026,
    style: {
      stopColor: "#202F59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2467,
    style: {
      stopColor: "#30375D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4156,
    style: {
      stopColor: "#484563"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6032,
    style: {
      stopColor: "#685B6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8036,
    style: {
      stopColor: "#947A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2A884"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,0 1920,0 1920,1080 0,1080 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientBd);
export default __webpack_public_path__ + "static/media/gradient-bd.1c978784800644388fb1a525ffd39e92.svg";
export { ForwardRef as ReactComponent };